import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MediaQueries } from "../../components/utils";
import ProfileView from "../../components/Myaccount/ProfileView"
import MyAccountDashboard from "../../components/Myaccount/MyAccountDashboard";


const MyAccount = () => {

    const { isMobile } = MediaQueries()

    return (
        < >
            <Container fluid className="homepagecontainer">
                <Row className="mt-4">
                    <Col lg={3}>
                        <MyAccountDashboard />
                    </Col>

                    {
                        !isMobile &&
                        <Col lg={9}>
                            <div className="Myaccount-rightsidecard">
                                <div className="title">Profile</div>
                                <div className="discription">Edit and save your personal address</div>
                                <ProfileView />
                            </div>
                        </Col>
                    }
                </Row>
            </Container>
        </>
    );
};

export default MyAccount;
